module.exports = __webpack_public_path__ + "static/img/4.f20407e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/4.png
// module id = Xxu8
// module chunks = 0